module.exports = __webpack_public_path__ + "img/tohoku-maas-sendai.bcdff3e5.png";